import React from 'react';

/**
 * Icône Applications Mobiles - Smartphone avec interface
 */
const MobileApps = ({
  size = 48,
  className = '',
  animate = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-mobile ${animate ? 'icon-animate' : ''} ${className}`}
    >
      <defs>
        <linearGradient id="mobileGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00d4ff" />
          <stop offset="100%" stopColor="#33ddff" />
        </linearGradient>
      </defs>

      {/* Smartphone */}
      <rect
        x="16"
        y="8"
        width="16"
        height="32"
        rx="2"
        stroke="url(#mobileGrad)"
        strokeWidth="2.5"
        fill="url(#mobileGrad)"
        fillOpacity="0.1"
      />

      {/* Écran */}
      <rect
        x="18"
        y="12"
        width="12"
        height="22"
        rx="0.5"
        fill="url(#mobileGrad)"
        fillOpacity="0.2"
      />

      {/* Icônes d'app (grille 2x2) */}
      <g opacity="0.9">
        <rect x="20" y="14" width="2.5" height="2.5" rx="0.5" fill="white" />
        <rect x="24" y="14" width="2.5" height="2.5" rx="0.5" fill="white" />
        <rect x="20" y="18" width="2.5" height="2.5" rx="0.5" fill="white" />
        <rect x="24" y="18" width="2.5" height="2.5" rx="0.5" fill="white" />
      </g>

      {/* Barre de progression/notification */}
      <rect
        x="20"
        y="24"
        width="8"
        height="1.5"
        rx="0.75"
        fill="white"
        opacity="0.7"
      />

      {/* Bouton home */}
      <circle
        cx="24"
        cy="36"
        r="1.5"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />

      {/* Signal/ondes */}
      <g opacity="0.5" transform="translate(34, 16)">
        <path d="M0 0 Q2 -2 4 0" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none" />
        <path d="M-1 2 Q2 -1 5 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      </g>
    </svg>
  );
};

export default MobileApps;
